module.exports = __webpack_public_path__ + "assets/img/punch_card.d2b27cba.png";